import React, { useState, useContext, useEffect } from 'react'
import { Form, Switch, Divider } from 'antd'
import { CreateMemberLyfeContext } from '../../../../../../..'
// import TooltipInfo from '../../../../../../../../CreateEventV2/TooltipInfo'
import HourForm from '../HourForm'
import './index.styl'

const { Item, List } = Form

const Sunday = ({ currentPageDetails }) => {
  const { form } = useContext(CreateMemberLyfeContext)

  const [sundaySwitch, setSundaySwitch] = useState(false)
  const [hours, setHours] = useState(form.getFieldValue('sunday') || [])
  // const mobile = window.innerWidth <= 730
  const hideDivider = window.innerWidth <= 1350
  // const tooltipTitle = `Charity Raffles are limited to $30,000 in total ticket sales and $100 max price per ticket

  // Ticket Lyfe charges for Charity Raffle Tickets are $1 for Raffles priced up to $50 and $2 for higher priced Raffle Tickets

  // Do not pick Charity Raffles if you are doing a regular event with Random Draw Prizes--Because you can do a Random Draw on ANY Ticket Lyfe Event, the Charity Raffle limits above will not apply, and Ticket Lyfe treat your event as an ordinary Ticketed Event`

  // const additionalTooltip = (
  //  <TooltipInfo
  //    className='tooltipTitle'
  //    text={mobile ? '' : 'Additional info'}
  //    info={tooltipTitle}
  //  />
  // )

  useEffect(() => {
    if (!!currentPageDetails?.workingHours?.sunday?.length) {
      setSundaySwitch(true)
      setHours(currentPageDetails.workingHours.sunday)
    }
  }, [currentPageDetails])

  useEffect(() => {
    if (!hours.length) {
      setSundaySwitch(false)
      form.setFieldsValue({
        sundaySwitch: false,
      })
    }
  }, [hours, form])

  const handleSwitchChange = checked => {
    setSundaySwitch(checked)
    if (checked && !hours.length) {
      const newHour = [{}]
      setHours(newHour)
      form.setFieldsValue({
        sunday: newHour,
      })
    }
  }

  const getSundayData = idx => {
    return hours[idx]
  }

  return (
    <div className='mondayWrapper sundayWrapper'>
      <div className={sundaySwitch ? 'betweenWraper active' : 'betweenWraper'}>
        <div className='radioWrapper'>
          <Item style={{ marginBottom: 0 }} name='sundaySwitch' valuePropName='checked' className='monday'>
            <Switch onChange={handleSwitchChange} />
          </Item>
          <div className='text'>Sunday</div>
        </div>
        {/* <div className='tooltipWrapper'>{additionalTooltip}</div> */}
      </div>
      {sundaySwitch && (
        <List name='sunday'>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }) => (
                <HourForm
                  fieldName='sunday'
                  categoryData={getSundayData(fieldKey)}
                  form={form}
                  key={key}
                  name={name}
                  fieldKey={fieldKey}
                  onRemove={index => {
                    remove(index)
                    const updatedHours = form.getFieldValue('sunday')
                    setHours(updatedHours)
                    if (updatedHours.length === 0) {
                      form.setFieldsValue({
                        sundaySwitch: false,
                      })
                    }
                  }}
                  {...restField}
                />
              ))}
              <div
                id='addCategory' className='addCategoryBtn' onClick={() => {
                  add()
                  const updatedHours = form.getFieldValue('sunday')
                  setHours(updatedHours)
                }}
              >Add Another Activity
              </div>
            </>
          )}
        </List>
      )}
      {!hideDivider &&
        <Divider />}
    </div>
  )
}

export default Sunday
